import { store } from "../store";
import { getCustomers } from "../store/selectors";
import { createCrudActions } from "../utils/crudGenerator";

const formatLaundrys = (data) => {
  if (!data) {
    return [];
  }
  const state = store.getState();
  const customers = getCustomers(state);

  const formatItem = (item) => {
    const customerName =
      customers && customers[item.customer]
        ? customers[item.customer].name
        : "";
    return {
      ...item,
      label: `${customerName ? `${customerName} - ` : ""}${item.name}`,
      value: item._id,
    };
  };

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchLaundrys,
  create: createLaundry,
  update: updateLaundry,
  delete: deleteLaundrys,
} = createCrudActions("LAUNDRY", "Lavanderia", formatLaundrys);
